<template>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn-secondary @click="$emit('close')">{{  $t("buttons.close") }}</v-btn-secondary>
    <v-btn-primary @click="$emit('update', coupon)">{{ $t("buttons.save") }}</v-btn-primary>
  </v-card-actions>
</template>

<script setup lang="ts">

defineProps({
  coupon: Object,
});

defineEmits(["close", "update"]);
</script>

